import Reveal from "@/components/base/Reveal";
import { timelineEvents } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          index="叁"
          title="线索时间线"
          desc="把公开记录按发生顺序铺开。单看任意一格都像巧合，连起来才成一条线。"
          actionLabel="查看完整时间轴"
          actionHref="#ranking"
        />

        <div className="relative">
          <div
            aria-hidden
            className="absolute left-0 right-0 top-[8px] hidden h-px bg-background-300 lg:block"
          />
          <ol className="grid grid-cols-1 gap-y-6 lg:grid-cols-6 lg:gap-x-5">
            {timelineEvents.map((event, i) => (
              <li key={event.date} className="relative">
                <span
                  aria-hidden
                  className="absolute left-[7px] top-4 bottom-[-24px] w-px bg-background-300 lg:hidden"
                />
                <span
                  aria-hidden
                  className="absolute left-0 top-1 h-3.5 w-3.5 rounded-full border-2 border-accent-500 bg-background-50 lg:top-[1px]"
                />
                <Reveal delay={i * 70}>
                  <div className="pl-8 lg:pl-0 lg:pt-7 lg:pr-2">
                    <span className="font-heading text-sm font-bold text-primary-600">
                      {event.date}
                    </span>
                    <h4 className="mt-1.5 font-heading text-sm font-bold leading-snug text-foreground-950 md:text-base">
                      <a href="#archive" className="cursor-pointer transition-colors hover:text-primary-600">
                        {event.title}
                      </a>
                    </h4>
                    <p className="mt-1.5 text-[11px] leading-relaxed text-foreground-600 md:text-xs">
                      {event.note}
                    </p>
                  </div>
                </Reveal>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}